module.exports = __webpack_public_path__ + "static/media/finance-lending-rate.2128c158.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/finance-lending-rate.mp4
// module id = 2579
// module chunks = 0